// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__gheLm","turning":"Loader_turning__z30yL"};